import React from 'react';
import cn from 'classnames';
import CompanyAvatarPlaceholderIcon from '@/assets/icons/company-avatar-placeholder.svg?react';
interface CompanyLogoProps {
  /** 公司 logo 图片地址 */
  imageUrl?: string;
  className?: string;
}

/**
 * 公司 Logo 组件
 * - 有 imageUrl 时展示图片
 * - 无 imageUrl 时展示 #F5F5F5 背景 + 建筑占位图标（设计稿）
 */
export const CompanyLogo: React.FC<CompanyLogoProps> = ({ imageUrl, className }) => {
  const baseClass = cn(
    'inline-flex items-center justify-center shrink-0 overflow-hidden  rounded-full w-7 h-7',
    className
  );

  if (imageUrl) {
    return (
      <div className={cn(baseClass, 'border border-[#E5E5E5]')}>
        <img src={imageUrl} alt="logo" className="w-full h-full object-cover block" />
      </div>
    );
  }

  return (
    <div className={cn(baseClass, 'bg-[#F5F5F5]  rounded-full')}>
      <CompanyAvatarPlaceholderIcon />
    </div>
  );
};
